$(function () {
    const wrapper = document.querySelector('.sidebar_wrapper[data-sidebar-preferences-url]');
    if (!wrapper) {
        return;
    }

    const sidebar = wrapper.querySelector(':scope > .sidebar');
    const sidebarContent = sidebar.querySelector('.sidebar-content');
    const favoritesSection = sidebar.querySelector('.sidebar-favorites');
    const favoritesList = sidebar.querySelector('.sidebar-favorites-list');
    const favoritesEditButton = sidebar.querySelector('.sidebar-favorites-edit');
    const pinButton = sidebar.querySelector('.sidebar-pin-toggle');
    const pinLabel = pinButton.querySelector('.sidebar-pin-label');
    const sourceLinksByKey = new Map();
    let favorites = [];
    let editingFavorites = false;
    let saving = false;
    let pendingSave = false;

    try {
        favorites = JSON.parse(wrapper.dataset.sidebarFavorites || '[]');
    } catch (error) {
        favorites = [];
    }

    const preferenceKey = (link) => link.dataset.openNestedTabHref || link.getAttribute('href');
    const sourceLinks = Array.from(sidebar.querySelectorAll('.sidebar-nav .sidebar-link'))
        .filter((link) => !link.closest('.sidebar-favorites') && preferenceKey(link)?.startsWith('#company-'));

    const positionPinnedMultilevel = (row) => {
        if (!wrapper.classList.contains('sidebar-pinned') || !window.matchMedia('(min-width: 992px)').matches) {
            return;
        }

        const multilevel = row.querySelector(':scope > .sidebar-multilevel');
        if (!multilevel) {
            return;
        }

        const rowRect = row.getBoundingClientRect();
        const top = Math.max(0, Math.min(rowRect.top, window.innerHeight - multilevel.offsetHeight));

        multilevel.style.setProperty('--sidebar-multilevel-left', `${rowRect.right}px`);
        multilevel.style.setProperty('--sidebar-multilevel-top', `${top}px`);
    };

    const positionOpenMultilevels = () => {
        sidebar.querySelectorAll('.sidebar-item:hover, .sidebar-item:focus-within')
            .forEach(positionPinnedMultilevel);
    };

    sidebar.addEventListener('mouseover', (event) => {
        const row = event.target.closest('.sidebar-item');
        if (row && sidebar.contains(row)) {
            positionPinnedMultilevel(row);
        }
    });
    sidebar.addEventListener('focusin', (event) => {
        const row = event.target.closest('.sidebar-item');
        if (row && sidebar.contains(row)) {
            positionPinnedMultilevel(row);
        }
    });
    sidebarContent.addEventListener('scroll', positionOpenMultilevels, { passive: true });
    window.addEventListener('resize', positionOpenMultilevels);

    sourceLinks.forEach((link) => {
        const key = preferenceKey(link);
        if (!sourceLinksByKey.has(key)) {
            sourceLinksByKey.set(key, link.cloneNode(true));
        }

        let row = link.closest('.sidebar-item');
        if (link.classList.contains('sidebar-item')) {
            row = document.createElement('div');
            row.className = 'sidebar-item sidebar-favorite-row';
            link.parentNode.insertBefore(row, link);
            link.classList.remove('sidebar-item');
            link.classList.add('stretched-link');
            row.appendChild(link);
        } else {
            row.classList.add('sidebar-favorite-row');
        }

        if (row.querySelector(':scope > .sidebar-favorite-toggle')) {
            return;
        }

        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'sidebar-favorite-toggle';
        button.dataset.favoriteKey = key;
        button.innerHTML = '<i class="far fa-star"></i>';
        row.insertBefore(button, row.querySelector(':scope > .sidebar-multilevel'));
    });

    favorites = Array.from(new Set(favorites)).filter((key) => sourceLinksByKey.has(key));

    const currentPreferences = () => ({
        pinned: wrapper.classList.contains('sidebar-pinned'),
        favorites,
    });

    const showSaveError = () => {
        const message = wrapper.dataset.sidebarSaveError;
        if (window.Swal) {
            Swal.fire({
                icon: 'error',
                title: message,
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
            });
        } else {
            console.error(message);
        }
    };

    const flushSave = () => {
        if (saving || !pendingSave) {
            return;
        }

        pendingSave = false;
        saving = true;

        $.ajax({
            url: wrapper.dataset.sidebarPreferencesUrl,
            type: 'PUT',
            contentType: 'application/json',
            data: JSON.stringify(currentPreferences()),
            headers: {
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
            },
        }).fail(showSaveError).always(() => {
            saving = false;
            flushSave();
        });
    };

    const savePreferences = () => {
        pendingSave = true;
        flushSave();
    };

    const syncSourceButtons = () => {
        sidebar.querySelectorAll('.sidebar-favorite-toggle').forEach((button) => {
            const isFavorite = favorites.includes(button.dataset.favoriteKey);
            button.classList.toggle('is-favorite', isFavorite);
            button.title = isFavorite ? wrapper.dataset.sidebarRemoveFavoriteLabel : wrapper.dataset.sidebarAddFavoriteLabel;
            button.querySelector('i').className = `${isFavorite ? 'fas' : 'far'} fa-star`;
        });
    };

    const syncFavoritesEditing = () => {
        const label = editingFavorites
            ? wrapper.dataset.sidebarFinishEditingFavoritesLabel
            : wrapper.dataset.sidebarEditFavoritesLabel;

        favoritesSection.classList.toggle('is-editing', editingFavorites);
        favoritesEditButton.classList.toggle('is-active', editingFavorites);
        favoritesEditButton.title = label;
        favoritesEditButton.querySelector('i').className = `fas ${editingFavorites ? 'fa-check' : 'fa-pen'}`;
    };

    const renderFavorites = () => {
        favoritesList.replaceChildren();

        favorites.forEach((key) => {
            const sourceLink = sourceLinksByKey.get(key);
            const row = document.createElement('div');
            const sortButton = document.createElement('button');
            const link = sourceLink.cloneNode(true);
            const removeButton = document.createElement('button');

            row.className = 'sidebar-item sidebar-favorite-item';
            row.dataset.favoriteKey = key;

            sortButton.type = 'button';
            sortButton.className = 'sidebar-favorite-sort';
            sortButton.title = wrapper.dataset.sidebarSortLabel;
            sortButton.innerHTML = '<i class="fas fa-sort"></i>';

            link.classList.remove('active', 'show', 'stretched-link', 'sidebar-item');
            link.classList.add('sidebar-favorite-link');

            removeButton.type = 'button';
            removeButton.className = 'sidebar-favorite-toggle is-favorite';
            removeButton.dataset.favoriteKey = key;
            removeButton.title = wrapper.dataset.sidebarRemoveFavoriteLabel;
            removeButton.innerHTML = '<i class="fas fa-star"></i>';

            row.append(sortButton, removeButton, link);
            favoritesList.appendChild(row);
        });

        favoritesSection.classList.toggle('d-none', favorites.length === 0);
        if (favorites.length === 0) {
            editingFavorites = false;
        }
        syncFavoritesEditing();
        syncSourceButtons();
    };

    favoritesEditButton.addEventListener('click', () => {
        editingFavorites = !editingFavorites;
        syncFavoritesEditing();
    });

    sidebar.addEventListener('click', (event) => {
        const button = event.target.closest('.sidebar-favorite-toggle');
        if (!button) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();

        const key = button.dataset.favoriteKey;
        favorites = favorites.includes(key)
            ? favorites.filter((favorite) => favorite !== key)
            : [...favorites, key];

        renderFavorites();
        savePreferences();
    });

    const syncPinButton = () => {
        const isPinned = wrapper.classList.contains('sidebar-pinned');
        const label = isPinned ? wrapper.dataset.sidebarUnpinLabel : wrapper.dataset.sidebarPinLabel;
        pinButton.classList.toggle('is-pinned', isPinned);
        pinButton.title = label;
        pinLabel.textContent = label;
    };

    pinButton.addEventListener('click', () => {
        wrapper.classList.toggle('sidebar-pinned');
        syncPinButton();
        window.dispatchEvent(new Event('resize'));
        savePreferences();
    });

    Sortable.create(favoritesList, {
        animation: 150,
        handle: '.sidebar-favorite-sort',
        ghostClass: 'sidebar-favorite-ghost',
        onEnd: () => {
            favorites = Array.from(favoritesList.children).map((item) => item.dataset.favoriteKey);
            savePreferences();
        },
    });

    syncPinButton();
    renderFavorites();
});
